export const CLAIMS = {
  SITES_READ_ALL: 'sites:read_all',
  PARTICIPANTS_READ_ALL: 'participants:read_all',
};
